import React from 'react';
import NoData from 'assets/no_data.svg?react';
import Flex from 'ui/Flex/Flex';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyNoDataContainer = styled(Box, {
    name: 'StyNoDataContainer',
})({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    textAlign: 'center',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    fontSize: '1em',

    '& p': {
        marginLeft: '1rem',
        lineHeight: 'normal',
    },
});
type Props = {
    text: string;
};

const NoDataResume = ({ text }: Props) => (
    <Flex align="center" m={1}>
        <StyNoDataContainer>
            <NoData />
            <p>{text}</p>
        </StyNoDataContainer>
    </Flex>
);

export default NoDataResume;
